import React from 'react';
import { Star } from 'lucide-react';

const CommissionTab = ({ customer, logs, loading }) => (
  <div className="space-y-4">
    <div className="bg-purple-50 border border-purple-200 rounded-xl p-4">
      <p className="text-sm font-medium text-purple-800 flex items-center gap-1">
        <Star className="w-4 h-4" />代理推广数据
      </p>
      <div className="grid grid-cols-3 gap-3 mt-3">
        <div className="text-center">
          <p className="text-xl font-bold text-purple-600">{customer.agent_total_referrals || 0}</p>
          <p className="text-xs text-gray-500">推广次数</p>
        </div>
        <div className="text-center">
          <p className="text-xl font-bold text-green-600">${parseFloat(customer.agent_total_earnings || 0).toFixed(2)}</p>
          <p className="text-xs text-gray-500">累计佣金</p>
        </div>
        <div className="text-center">
          <p className="text-xl font-bold text-blue-600">{customer.agent_commission_rate}%</p>
          <p className="text-xs text-gray-500">分成比例</p>
        </div>
      </div>
      <p className="text-xs text-purple-600 mt-2">
        优惠码：<span className="font-mono font-bold">{customer.agent_code}</span>
      </p>
    </div>

    {loading ? (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto"></div>
      </div>
    ) : logs.length === 0 ? (
      <p className="text-xs text-gray-400 text-center py-4">暂无佣金记录</p>
    ) : (
      <div className="space-y-2">
        {logs.map(log => (
          <div key={log.id} className="flex items-center justify-between bg-gray-50 rounded-lg px-3 py-2">
            <div>
              <p className="text-sm font-medium text-gray-700">{log.notes || '佣金收入'}</p>
              <p className="text-xs text-gray-400">{log.related_order_no}</p>
              <p className="text-xs text-gray-400">
                {new Date(log.created_at_ts * 1000).toLocaleString()}
              </p>
            </div>
            <p className="text-sm font-bold text-green-600">+${parseFloat(log.amount).toFixed(2)}</p>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default CommissionTab;